// extracted by mini-css-extract-plugin
export default {"main":"Stock_main__9SnjZ","window":"Stock_window__0ElO-","pagesContainer":"Stock_pagesContainer__0SRYL"};